import React from "react"
import ServicesData from "../data/services.json"
import _ from "lodash"
import Service from "./service"
import Section from "./section"

const Services = () => {
  const renderData = data => {
    let dataArrays = _.chunk(data, 3)
    let res = dataArrays.map((arrays, indexa) => {
      return (
        <div className="row">
          {arrays.map((data, indexb) => {
            return <Service key={"si_" + indexa + indexb} service={data} />
          })}
        </div>
      )
    })
    return res
  }
  return <Section Id="servicios" title="Nuestros Servicios">{renderData(ServicesData)}</Section>
}

export default Services
